module.exports = __webpack_public_path__ + "img/v1.6.e6fbe10e.png";